import { createSlice } from '@reduxjs/toolkit';
import type {
  TirePattern,
  TirePatternPosition,
} from 'types/tire-pattern.types';

export interface InitialStateType {
  tirePatterns: TirePattern[];
  tirePatternPositions: TirePatternPosition[];
}

const initialState: InitialStateType = {
  tirePatterns: [],
  tirePatternPositions: [],
};

export const tirePatternSlice = createSlice({
  name: 'tirePattern',
  initialState,
  reducers: {
    setTirePatterns(state, { payload }) {
      state.tirePatterns = payload;
    },
    setTirePatternPositions(state, { payload }) {
      state.tirePatternPositions = payload;
    },
  },
});

export const { setTirePatterns, setTirePatternPositions } =
  tirePatternSlice.actions;
export default tirePatternSlice.reducer;
